module.exports = __webpack_public_path__ + "624c1255/img/64000000-6.37ac333e.png";